import React from "react";
import { CategoryPageHeaderTemplate } from "themes/application/categories/components";

function CategoryPageHeader(props) {
    return <CategoryPageHeaderTemplate {...props} />;
}

export default CategoryPageHeader;
